import { IMPORT_TYPE_ID } from 'customer-data-filters-ui/constants/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Import = ObjectDefinitionRecord({
  enableAsAssociatedType: false,
  hasAccess: (_, hasScope) => hasScope('crm-import-read'),
  objectTypeId: IMPORT_TYPE_ID,
  referenceObjectType: 'IMPORT_PROPERTIES'
});
export default Import;